(function($) { $(document).ready(function() {

    if ($(".nature-swiper").length > 0) {
        let nature_swiper = new Swiper('.nature-swiper', {
            freeMode: false,
            slidesPerView: 'auto',
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                // when window width is >= 640px
                960: {
                    slidesPerView: 1,
                }
            }
        });
    }
}); })( jQuery );